import { c as _c } from "react/compiler-runtime";
import { isAmexOffer } from '@cc-shopping/utils/offers';
import type { BoxProps } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { useCompareContext } from '../../../Context';
import { useCreditCardCompareColumnContext } from '../../ColumnContext';
import { DetailBox } from '../../components/DetailBox';
type MobileContainerProps = {
  additionalProps?: BoxProps;
};
export function MobileContainer(t0) {
  const $ = _c(6);
  const {
    additionalProps,
    children
  } = t0;
  const {
    index
  } = useCreditCardCompareColumnContext();
  const {
    offersToShow
  } = useCompareContext();
  const isAnyAmexOffer = offersToShow.some(_temp);
  const t1 = isAnyAmexOffer ? "Recommended Credit" : "Recommended Credit Score";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      px: 0
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== additionalProps || $[2] !== children || $[3] !== index || $[4] !== t1) {
    t3 = <DetailBox title={t1} index={index} containerProps={additionalProps} contentContainerProps={t2}>{children}</DetailBox>;
    $[1] = additionalProps;
    $[2] = children;
    $[3] = index;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(offer) {
  return offer && isAmexOffer(offer);
}